import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';

export default function SelectComponent({
  name,
  options,
  isMulti,
  onChange,
  ...rest
}) {
  const handleChange = (selectedOption) => {
    const selectedValues = Array.isArray(selectedOption)
      ? selectedOption.map((option) => {
          return option.value;
        })
      : selectedOption.value;

    if (onChange) {
      onChange(selectedValues);
    }
  };

  return (
    <Select
      name={name}
      isMulti={isMulti}
      options={options}
      onChange={handleChange}
      {...rest}
    />
  );
}

SelectComponent.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ).isRequired,
  isMulti: PropTypes.bool,
  onChange: PropTypes.func,
};

SelectComponent.defaultProps = {
  isMulti: false,
  onChange: () => {},
};
